import React, { useState, useEffect, useMemo, useContext } from 'react'
import styles from './SalesOfMonth.module.css'
import Text from '../../components/text/Text'
import { TransactionResponse, saleDateFormat } from '../../services/commerce'
import { format, startOfMonth, subMonths, endOfMonth } from 'date-fns'
import SvgIcon, { iconNames } from '../../components/svgIcon/SvgIcon'
import {
    addSales,
    currencyFormat,
    getIncrease,
    sortSales,
} from '../../formatters'
import { clevertapEvents, labels } from '../../labels'
import routes from '../../router/routes'
import { useNavigate } from 'react-router-dom'
import { FeatureContext } from '../../context/useFeatureFlagContext'
import SaleComponent from '../../components/saleComponent/SaleComponent'
import { getTransaccionesLocalPorFechasTipoPago } from '../../services/commerce'
import { track } from '../../ClevertapWrapper'
import { getLocal } from '../../Utils/Profile'

export default function SalesOfMonth() {
    const { features } = useContext(FeatureContext)
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const [sales, setSales] = useState<TransactionResponse[]>([])
    const navigate = useNavigate()
    const [prevSales, setPrevSales] = useState<TransactionResponse[]>([])
    const salesEventParms = {
        pageName: 'SalesOfMonth',
        pageURL: routes.sales,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        nombreComercio: user?.sNombre,
        codLocal: user?.cLocal[0].sLocal,
        rut: user?.sRut,
        mailLogin: user?.sEmailContacto,
    }
    const getSales = async (startDate: string, endDate: string) => {
        return await getTransaccionesLocalPorFechasTipoPago(
            user.sEstablecimiento,
            getLocal(),
            startDate,
            endDate
        )
    }
    const getActualSales = async () => {
        await getSales(
            format(startOfMonth(new Date()), saleDateFormat),
            format(new Date(), saleDateFormat)
        ).then((data) => {
            setSales(data)
        })
    }

    const getPrevSales = async () => {
        const prevMonth = subMonths(new Date(), 1)
        const start = startOfMonth(prevMonth)
        const end = endOfMonth(start)
        await getSales(
            format(start, saleDateFormat),
            format(end, saleDateFormat)
        ).then((data) => {
            setPrevSales(data)
        })
    }
    const goToSaleDetails = () => {
        navigate(routes.salesDetails)
        track(
            clevertapEvents.amiposweb_administratunegocio_resumendeventas_detallesventas,
            salesEventParms
        )
    }
    const actualSalesAmmount = useMemo(() => {
        return sales
            .filter((item) => item.sEstadoTx !== 'ANULADA')
            .reduce(addSales, 0)
    }, [sales])

    const incress = useMemo(() => {
        const prevTotal = prevSales
            .filter((item) => item.sEstadoTx !== 'ANULADA')
            .reduce(addSales, 0)
        return getIncrease(prevTotal, actualSalesAmmount)
    }, [actualSalesAmmount, prevSales])

    const lastMovements = useMemo(() => {
        const sorted = sortSales(sales)
        return sorted.slice(0, 15)
    }, [sales])

    useEffect(() => {
        getActualSales()
        getPrevSales()
    }, [])

    const handlerRefresh = () => {
        getActualSales()
        getPrevSales()
    }

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <Text
                    fontSize={24}
                    color="#184287"
                    fontWeight={600}
                    marginBottom={15}
                    label={labels.monthSales}
                />
                <div className={styles.header}>
                    <div className={styles.headerAmountPercentage}>
                        <Text
                            label={`${incress}${labels.incressPercentage}`}
                            fontWeight={600}
                            color="#787878"
                            fontSize={14}
                        />
                        <div style={{ marginLeft: 10 }}>
                            <SvgIcon
                                width={17}
                                height={17}
                                iconName={
                                    incress > 0
                                        ? iconNames.arrowUp
                                        : iconNames.arrowDown
                                }
                            />
                        </div>
                    </div>
                    <Text
                        label={currencyFormat(actualSalesAmmount)}
                        fontWeight={600}
                        color="#74BF00"
                        fontSize={48}
                    />
                </div>
                <div className={styles.body}>
                    <Text
                        label="Últimos movimientos"
                        marginBottom={15}
                        fontWeight={600}
                        color="#63666A"
                        fontSize={18}
                    />
                    <div className={styles.bodyContent}>
                        {lastMovements.map((element) => (
                            <div
                                className={styles.bodyItem}
                                key={element.idTransaccion}
                            >
                                <SaleComponent
                                    sale={element}
                                    handlerRefresh={handlerRefresh}
                                />
                            </div>
                        ))}
                    </div>
                </div>
                {features.bottomBar.sales && (
                    <div className={styles.buttonContainer}>
                        <button
                            className={styles.buttonDetails}
                            onClick={goToSaleDetails}
                            type="button"
                        >
                            <Text
                                label={labels.goToSaleDetails}
                                fontWeight={600}
                                fontSize={14}
                                color="#fff"
                            />
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}
